import { Typography } from '@mui/material';
import { Grid } from '@mui/system';
import React from 'react';
import { TextFieldWithPrefix } from 'framework/ui/field';
import UpdateIcon from '@mui/icons-material/Update';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';

interface HealthcheckRowProps {
  label: string;
  children: React.ReactNode;
  lastUpdateValue?: string;
  isUpdateVisible?: boolean;
  onEdit?: () => void;
}

const HealthcheckRow = ({ label, children, lastUpdateValue, isUpdateVisible = false, onEdit }: HealthcheckRowProps) => {
  const { isAccessGranted } = useProjectSecurityContext();

  const { datesDifference, getToday, formatDate } = useDateService();

  const formattedLastUpdate = formatDate(lastUpdateValue, DATE_FORMAT.FULL_DATE);
  const tooltipLabel = label.replace(/:\s*$/, '');
  const updateTooltipTitle = formattedLastUpdate
    ? `${tooltipLabel} was updated on ${formattedLastUpdate}`
    : `No updates yet for ${tooltipLabel}`;

  return (
    <Grid container direction="row" gap={1} size={12} alignItems={'center'} sx={{ minHeight: '50px' }}>
      <Grid size={3}>
        <Typography color="textSecondary">{label}</Typography>
      </Grid>
      <Grid size={'grow'} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {children}
      </Grid>
      <Grid size={0.2} />
      <Grid size={2.2}>
        <TextFieldWithPrefix
          label={''}
          value={lastUpdateValue}
          format={str => datesDifference(getToday(), str)}
          tooltipProps={{
            title: updateTooltipTitle,
            children: <UpdateIcon fontSize="small" sx={{ color: 'text.secondary' }} />,
          }}
        />
      </Grid>
      {isAccessGranted(ACCESS_INFO_SECTIONS.CONTROL_PLANE, ACCESS_INFO_ACTIONS.MANAGE) && (
        <Grid size={0.5} display={'flex'} justifyContent={'center'}>
          {isUpdateVisible ? (
            <IconButton onClick={onEdit}>
              <AppRegistrationIcon color="primary" />
            </IconButton>
          ) : (
            <></>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default HealthcheckRow;
